export default __webpack_public_path__ + "static/media/copy-to-Davinci-DB.e17cff7c.svg";